<template>
  <ContentHelpCard
    :data="item"
    class="mt-[36px]"
    :words="keyword"
    :titleLink="goLink(item?.display_title)"
    :descLink="goLink(item?.display_content)"
  >
    <template #other>
      <div class="text-font-50 text-14 mt-[12px]">
        {{ item?.column_title }} | {{ item?.document_name }}
        <span v-if="item.update_time">
          {{ $t('zui-jin-geng-xin') }}
          {{ timeFormat(item?.update_time, 'YYYY-MM-DD HH:mm') }}
        </span>
      </div>
    </template>
  </ContentHelpCard>
</template>

<script lang="ts" setup>
import { SEARCH_TYPE, type IHelpSearch } from '~/api/index'
import { useTime } from '~/hooks/useTime'
import { PageKey } from '~/constants/page'

const props = defineProps<{
  item: IHelpSearch
  keyword: string[]
}>()

const { timeFormat } = useTime()

const checkHightLight = (text: string) => {
  if (!props.keyword?.length) {
    return text
  }
  if (!text) {
    return
  }
  let newText = text
  props.keyword.map((item) => {
    const reg = new RegExp(item, 'g')
    newText = newText.replace(reg, '<span class="text-primary">$&</span>')
    return text
  })
  return newText
}

const goLink = (item: { text: string; anchor_point_id: number }) => {
  if (props.item.model_type === SEARCH_TYPE.COMPANY_CASE) {
    return {
      name: PageKey.CASE_DETAIL,
      params: {
        id: props.item.model_id,
      },
    }
  } else if (props.item.model_type === SEARCH_TYPE.CLASS) {
    return {
      name: PageKey.TUTORIAL_INFO,
      params: {
        id: props.item.model_id,
      },
    }
  } else {
    return {
      name: PageKey.HELP_CENTER_DETAIL,
      params: {
        id: `${props.item.column_id}${props.item.model_id ? `-${props.item.model_id}` : ''}`,
      },
      ...(item.anchor_point_id && {
        query: {
          target: item.anchor_point_id,
        },
      }),
    }
  }
}
</script>

<style lang="scss" scoped>
.result-item {
  @apply mt-[36px];
}
</style>
